import Vue from "./../init";

const uri = "user";

var customActions = {
  getRegistrationData: { method: "GET", url: uri + "/registration" },
  getAccountToBeTransfered: { method: "GET", url: uri + "/transfer/{id}" },
  transferSteamId: { method: "POST", url: uri + "/transfer" },
  checkUnique: { method: "GET", url: uri + "/unique" },
  checkPasswordStrength: { method: "POST", url: uri + "/password-strength" },

  sendPasswordReminder: { method: "POST", url: uri + "/password/reminder" },
  resetPassword: { method: "POST", url: uri + "/password/reset/{id}" },

  setAvatar: { method: "PUT", url: uri + "/avatar" },

  authCodeInit: { method: "GET", url: uri + "/auth/code" },
  authCodeActivate: { method: "POST", url: uri + "/auth/code" },
  authCodeDeactivate: { method: "DELETE", url: uri + "/auth/code" },

  authCodeRemind: { method: "POST", url: uri + "/auth/code/reset" },
  authCodeReset: { method: "GET", url: uri + "/auth/code/reset/{id}" },

  activate: { method: "GET", url: uri + "/activate/{id}" },
  sendActivationEmail: { method: "POST", url: uri + "/activate/resend" },

  unsubscribe: { method: "DELETE", url: uri + "/unsubscribe/{id}" },

  disconnectThirdParty: {
    method: "DELETE",
    url: uri + "/disconnect/{provider}"
  }
};

export const UserResource = Vue.resource(uri, {}, customActions);
